import { Participant } from "./Participant";

export class DefinitionParticipant extends Participant {
    private _name: string;
    private _identifier: string;

    public condition: string;
    public roleName: string;

    constructor(identifier: string, name: string, condition: string, roleName: string) {
        super();

        if (!name)
            throw new Error("Required property 'name' not provided. Could not create DefinitionParticipant.");

        this._identifier = identifier;
        this._name = name;
        this.condition = condition;
        this.roleName = roleName;
    }

    public get name(): string {
        return this._name;
    }

    public set name(newName: string) {
        this._name = newName;
    }

    public get identifier(): string {
        return this._identifier;
    }
}
